/* eslint zillow/import/prefer-default-export: 0 */
export const HERO_HEADLINE = 'Agents. Tours. \nLoans. Homes.';
export const UNDISCLOSED_ADDRESS_TEXT = '(Undisclosed Address)';
export const DEFAULT_CAROUSEL_TITLE = 'Homes you might like';
export const SAVE_HOME_ERROR_MESSAGE = "We're unable to save. Try refreshing this page.";
export const UNSAVE_HOME_ERROR_MESSAGE = "We're unable to un-save. Try refreshing this page.";
export const SIGNED_OUT_GATED_COLLECTION_HEADING = 'Get home recommendations';
export const SIGNED_IN_GATED_COLLECTION_HEADING = 'Recommendations underway';
export const SIGNED_OUT_GATED_COLLECTION_SUBTITLE = 'Sign in for a more personalized experience.';
export const SIGNED_IN_GATED_COLLECTION_SUBTITLE =
    "Search and save a few homes you like and we'll find recommendations for you.";
export const REG_LOGIN_HEADER_FROM_COLLECTION =
    'Sign in or register to receive personalized recommendations';
export const MORE_RECS_TEXT = 'More recommended homes';
export const HOME_RECS_FOOTER_HEADING = "About Zillow's Recommendations";
export const HOME_RECS_FOOTER_TEXT =
    "Recommendations are based on your location and search activity, such as the homes you've viewed and saved and the filters you've used. We use this information to bring similar homes to your attention, so you don't miss out.";

export const META_DESCRIPTION =
    'The leading real estate marketplace. Search millions of for-sale and rental listings, compare Zestimate® home values and connect with local professionals.';
export const HOMEPAGE_TITLE = 'Zillow: Real Estate, Apartments, Mortgages & Home Values';
